<template>
  <div class="flex items-center gap-2">
    <router-link
      v-if="!$isEmpty(newsroom)"
      :to="newsroomPathConfig"
      class="shrink-0"
    >
      <round-avatar
        :main-color="newsroom.main_color"
        :src="newsroomLogo"
        :acronym-fallback="newsroom.name"
        size="xsmall"
      />
    </router-link>

    <router-link
      v-if="!$isEmpty(newsroom)"
      :title="newsroom.name"
      :to="newsroomPathConfig"
      class="min-w-0 truncate font-display text-sm font-semibold text-ink transition-colors hover:text-accent"
      data-testid="StoryCard_NewsroomLink"
    >
      {{ newsroom.name }}
    </router-link>

    <time
      v-if="!hideDate"
      :datetime="story.published_at"
      class="shrink-0 whitespace-nowrap font-display text-sm font-medium text-muted-faint"
    >
      · {{ datetime(story.published_at, 'MMMM Do') }}
    </time>

    <!-- Inline meta (story type + country) — used by the larger/featured card,
         which surfaces these in the head row instead of under the title. -->
    <slot name="meta" />

    <div class="ml-auto flex shrink-0 items-center gap-1.5">
      <slot />
    </div>
  </div>
</template>

<script>
import DatetimeMixin from '@/shared/js/mixins/DatetimeMixin'

export default {
  mixins: [DatetimeMixin],

  props: {
    newsroom: { type: Object, required: true },
    story: { type: Object, required: true },
    newsroomPathName: { type: String, required: true },
    hideDate: { type: Boolean, default: false }
  },

  computed: {
    newsroomLogo () {
      return this.$safeGet(this.newsroom, 'logo.cropped')
    },

    newsroomPathConfig () {
      return {
        name: this.newsroomPathName,
        params: { newsroomId: this.newsroom.id, newsroomSlug: this.story.newsroom_slug }
      }
    }
  }
}
</script>
